// File: team-v2/components/dashboard/TeamProgressBox.js

import React from 'react';
import { Box, Typography } from '@mui/material';
import { ArrowForwardIcon, DoneIcon, CheckCircleIcon } from 'icons/materialIcons';

// Gradient border styles (copied from individual plan)
const createGradientBorderStyles = (borderRadius = '12px') => ({
    position: 'relative',
    '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        borderRadius: borderRadius,
        border: '1px solid transparent',
        background: 'linear-gradient(to bottom right, #36dad6, #685ed1) border-box',
        WebkitMask: 'linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0)',
        WebkitMaskComposite: 'destination-out',
        mask: 'linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0)',
        maskComposite: 'exclude',
        pointerEvents: 'none'
    }
});

const TeamProgressBox = ({ title, description, completed, onClick, width = '350px' }) => {
    return (
        <Box
            sx={{
                width: width,
                backgroundColor: completed ? '#f1f7fa' : 'white',
                border: '1px solid',
                borderColor: completed ? '#dee3e6' : '#ededed',
                borderRadius: '8px',
                padding: '16px',
                cursor: 'default',
                transition: 'all 0.2s ease',
                position: 'relative',
                height: '100px',
                minHeight: '100px',
                maxHeight: '100px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center'
            }}
        >
            {completed ? (
                <>
                    <Box
                        sx={{
                            width: '16px',
                            height: '16px',
                            borderRadius: '50%',
                            backgroundColor: '#29aef8',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginBottom: '16px',
                        }}
                    >
                        <DoneIcon sx={{ color: 'white', fontSize: '12px' }} />
                    </Box>
                    <Typography
                        align="center"
                        sx={{
                            fontFamily: 'Inter, sans-serif',
                            fontSize: '12px',
                            fontWeight: 600,
                            color: '#000',
                            margin: 0,
                            lineHeight: '17.16px',
                            WebkitFontSmoothing: 'antialiased',
                            boxSizing: 'border-box',
                            cursor: 'default',
                            display: 'block',
                            height: '17.15px',
                            outline: 'none'
                        }}
                    >
                        {title}
                    </Typography>
                </>
            ) : (
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', width: '100%' }}>
                    <Box sx={{ flex: 1 }}>
                        <Typography
                            sx={{
                                fontFamily: 'Inter, sans-serif',
                                fontSize: '12px',
                                fontWeight: 600,
                                color: '#000',
                                margin: 0,
                                marginBottom: '8px',
                                lineHeight: '17.16px',
                                WebkitFontSmoothing: 'antialiased',
                                boxSizing: 'border-box',
                                cursor: 'default',
                                display: 'block',
                                height: '17.15px',
                                outline: 'none'
                            }}
                        >
                            {title}
                        </Typography>
                        <Typography
                            sx={{
                                fontFamily: 'Inter, sans-serif',
                                fontSize: '12px',
                                fontWeight: 500,
                                color: '#000',
                                margin: 0,
                                lineHeight: '17.16px',
                                WebkitFontSmoothing: 'antialiased',
                                boxSizing: 'border-box',
                                cursor: 'default',
                                display: 'block',
                                height: 'auto',
                                width: '100%',
                                outline: 'none'
                            }}
                        >
                            {description}
                        </Typography>
                    </Box>
                    <ArrowForwardIcon sx={{
                        color: '#000',
                        marginLeft: '12px',
                        fontSize: '16px',
                        height: '16px',
                        width: '16px',
                        minWidth: '16px',
                        boxSizing: 'border-box',
                        cursor: 'pointer',
                        display: 'block'
                    }} />
                </Box>
            )}
        </Box>
    );
};

export default TeamProgressBox;
